"use client";

import { c as _c } from "react/compiler-runtime";
import { PERSONAS } from "@opensea/navigation";
import { Button } from "@opensea/next-ui-kit";
import { Switch } from "@opensea/ui-kit";
import { FlashOn } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { usePersonaSwitch } from "@/hooks/use-persona-switch";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemSide, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuPersonaItem(t0) {
  const $ = _c(23);
  let isSheet;
  let onClick;
  let rest;
  if ($[0] !== t0) {
    ({
      isSheet,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isSheet;
    $[2] = onClick;
    $[3] = rest;
  } else {
    isSheet = $[1];
    onClick = $[2];
    rest = $[3];
  }
  const {
    persona,
    togglePersona
  } = usePersonaSwitch();
  const [playSelect] = usePlaySound(Sound.Select);
  const t = useTranslations("MoreMenuPersonaItem");
  let t1;
  if ($[4] !== onClick || $[5] !== playSelect || $[6] !== togglePersona) {
    t1 = e => {
      togglePersona();
      playSelect();
      onClick?.(e);
    };
    $[4] = onClick;
    $[5] = playSelect;
    $[6] = togglePersona;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== isSheet) {
    t2 = isSheet ? <Button icon={FlashOn} size="lg" variant="secondary" /> : <MoreMenuItemAvatar icon={FlashOn} />;
    $[8] = isSheet;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t) {
    t3 = t("title");
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <MoreMenuItemContent><MoreMenuItemTitle>{t3}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = persona === PERSONAS.advanced;
  let t6;
  if ($[14] !== t5) {
    t6 = <MoreMenuItemSide><Switch checked={t5} id="persona" /></MoreMenuItemSide>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isSheet || $[17] !== rest || $[18] !== t1 || $[19] !== t2 || $[20] !== t4 || $[21] !== t6) {
    t7 = <MoreMenuItem isSheet={isSheet} onClick={t1} {...rest}>{t2}{t4}{t6}</MoreMenuItem>;
    $[16] = isSheet;
    $[17] = rest;
    $[18] = t1;
    $[19] = t2;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}